import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Provider } from 'react-redux';
import { sideMenuStore } from "./store";
import { Container } from "./components/Container";
var SideMenu = function SideMenu(_ref) {
  var openElement = _ref.openElement,
    isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    user = _ref.user;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpenElement = _useState2[0],
    setIsOpenElement = _useState2[1];
  var handleClose = function handleClose() {
    onClose === null || onClose === void 0 ? void 0 : onClose();
    setIsOpenElement(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, openElement && /*#__PURE__*/React.createElement("div", {
    "data-t-id": "sideMenu-src"
  }, /*#__PURE__*/React.cloneElement(openElement, {
    onClick: function onClick() {
      return setIsOpenElement(true);
    }
  })), /*#__PURE__*/React.createElement(Provider, {
    store: sideMenuStore
  }, /*#__PURE__*/React.createElement(Container, {
    isAuth: !!user,
    isOpen: isOpen || isOpenElement,
    onClose: handleClose,
    "data-t-id": "sideMenu-src"
  })));
};
export { SideMenu };